import { useRef } from 'react';

/**
 * Stable string key for objects/arrays used in effect dependency lists.
 * Compares serialized content (not object identity) to avoid duplicate fetches.
 */
export function useStableKey(value) {
  const keyRef = useRef('');

  let nextKey = '';
  if (value != null) {
    try {
      nextKey = JSON.stringify(value);
    } catch {
      nextKey = String(value);
    }
  }

  if (keyRef.current !== nextKey) {
    keyRef.current = nextKey;
  }

  return keyRef.current;
}
